import WebAppLogo from '../../../resources/images/WebAppLogo.png';
import { ScreenType } from '../../../context_providers/screen_context/ScreenSizeProvider';
import { Box } from '@mui/material';
import { useHistory } from 'react-router-dom';

const NavbarLogo = ({ screenType }) => {
  const history = useHistory();

  const handleLogoClick = () => {
    history.push(`/`);
  };

  return (
    <Box
      sx={{
        marginRight: screenType === ScreenType.LARGE ? '30px' : '20px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
      }}
      onClick={handleLogoClick}
    >
      <img style={{ height: '40px' }} src={WebAppLogo} alt="Logo" />
    </Box>
  );
};

export default NavbarLogo;
